import "./CaseHoverCell.css";

const CaseHoverCell = ({
  caseData,
  onCaseClick,
  className = "",
  openInNewTab = false,
  children,
}) => {
  const client = caseData?.for_client;
  const caseHref = client?.id && caseData?.id ? `/bp-case/${client.id}/${caseData.id}` : undefined;
  const clientName = [client?.first_name, client?.last_name].filter(Boolean).join(" ");

  const handleCaseClick = (event) => {
    // Preserve browser shortcuts instead of routing them through the case loader.
    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.ctrlKey ||
      event.metaKey ||
      event.shiftKey ||
      event.altKey
    ) {
      return;
    }

    onCaseClick?.(event);
  };

  return (
    <td className={`case-hover-cell text-start ${className}`}>
      <a
        className="case-hover-cell__action case-hover-cell__action--load"
        href={caseHref}
        target={openInNewTab ? "_blank" : undefined}
        rel={openInNewTab ? "noopener noreferrer" : undefined}
        onClick={openInNewTab ? undefined : handleCaseClick}
        aria-label={`${openInNewTab ? "Open Case in a New Tab" : "Click to Load Case"}: ${clientName}`}
      >
        Click to Load Case
      </a>
      <a
        className="case-hover-cell__information"
        href={caseHref}
        target={openInNewTab ? "_blank" : undefined}
        rel={openInNewTab ? "noopener noreferrer" : undefined}
        onClick={openInNewTab ? undefined : handleCaseClick}
        aria-label={`${openInNewTab ? "Open Case in a New Tab" : "Load case for"} ${clientName}`}
      >
        {children}
      </a>
      <a
        className="case-hover-cell__action case-hover-cell__action--new-tab"
        href={caseHref}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={`Open Case in a New Tab: ${clientName}`}
      >
        In a New Tab
      </a>
      <span className="case-hover-cell__frame" aria-hidden="true" />
    </td>
  );
};

export default CaseHoverCell;
